module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEUSURBVHgB7VTREYIwDE1dwI7QDWQER2AD2UA2UidwBNgAnQBGwAkwOR4HYlL4VnL3rqVJXpo0hGiTnxe3ZNB1neclATyOW8ZD4JxrY/67CPGRUfC2YpxA3gCyP4uObe5iS2uFjYMQA4uOw0UQKKwxrhlpJLg3dBmjsnzFIAV5MIgLEFTYW3bfF4SislKEUzb5zvE+FAkSpofFlGDmkGhk8EkMn6FBPrqoIVteypm0pzfsRRdodkur/n5evqEMGrNaIijySJAEQS5ArZVn8pY5GdHzhUxSwCv6ocV1ciXFS7f044zEZlYu4phRPw5ESsaTxkYIjAP180nkxjPpqvGsGXaBlyPI9jiWrpJhVzJxQ5v8t7wBCNBXTeP0+fMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/df9483e.png
// module id = kzQi
// module chunks = 1